module.exports = __webpack_public_path__ + "static/media/Material-Design-Iconic-Font.b351bd62.ttf";